import { useMutation } from '@tanstack/react-query'
import { formatDateTimeUTC, formatTimeToHHMMSS } from '../../../../common/helpers/DateHandlers'
import { useStateCallback } from '../../../../common/hooks/useStateCallback'
import { ICustomerDetail } from '../../../../common/interfaces'
import { FileService } from '../../../../services/FileService'

interface IProps {
  customerDetail: ICustomerDetail
}

function getFileNameFromBucketPath(path: string) {
  return path.substring(path.lastIndexOf('/') + 1, path.length)
}

export const ContractDocumentTable = ({ customerDetail }: IProps) => {
  const [fileUrl, setFileUrl] = useStateCallback('')
  const downloadMutation = useMutation({
    mutationFn: () => FileService().downloadFromAzure(fileUrl),
    onSuccess: async (data) => {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', getFileNameFromBucketPath(fileUrl))

      document.body.appendChild(link)
      link.click()

      await new Promise((resolve) => setTimeout(resolve, 1000))

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
  })
  return (
    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
      {customerDetail.contracts.length ? (
        <>
          <thead>
            <tr className='fw-bolder text-muted'>
              <th className='w-150px'>FECHA</th>
              <th>CANAL</th>
              <th>MEDIO</th>
              <th>DOCUMENTO</th>
              <th className='text-center'>ADJUNTO</th>
            </tr>
          </thead>
          <tbody>
            {customerDetail.contracts
              .sort(
                (a, b) =>
                  new Date((b.date || null) as any).getTime() -
                  new Date((a.date || null) as any).getTime()
              )
              .map((e, i) => {
                let currentDate = new Date((e.date || null) as any)
                return (
                  <tr key={i}>
                    <td className='text-muted'>
                      {e.date ? (
                        <>
                          <span className='text-muted d-block fs-5'>
                            {formatDateTimeUTC(currentDate.toDateString())}
                          </span>
                          <span className='text-muted d-block fs-5'>
                            {formatTimeToHHMMSS(currentDate)}
                          </span>
                        </>
                      ) : (
                        '--'
                      )}
                    </td>
                    <td>
                      <span className='text-muted fs-5'>{e.channel_register ?? '--'}</span>
                    </td>
                    <td>
                  
                        <span className='text-muted fs-5'>
                        {[e.utm_source, e.utm_medium, e.utm_campaign]
                          .filter((v) => v && v !== 'undefined' && v.trim() !== '')
                          .join(', ') || '--'}
                      </span>
                    </td>
                    <td className='text-muted fs-5'>{decodeURIComponent(e.filename) ?? '--'}</td>
                    <td className={'text-center'}>
                      {e.path ? (
                        <div className='d-flex align-items-center  p-1 justify-content-center cursor-pointer'>
                          {downloadMutation.isLoading && e.path === fileUrl ? (
                            <div className='text-center text-muted'>
                              <div
                                className='spinner-border'
                                style={{
                                  width: '18px',
                                  height: '18px',
                                }}
                                role='status'
                              ></div>
                            </div>
                          ) : (
                            <div
                              onClick={() => {
                                if (downloadMutation.isLoading) {
                                  return
                                }
                                setFileUrl(e.path!)
                                downloadMutation.mutate()
                              }}
                              className='iconButton'
                            >
                              <i className='bi bi-download fs-3 m-2'></i>
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className='text-muted'>--</span>
                      )}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </>
      ) : (
        <span className='notFound text-muted text-muted fs-5 text-center'>
          No se encontraron contratos para este cliente
        </span>
      )}
    </table>
  )
}
